import { useNavigate } from "react-router-dom";

export default function Landing(){
  const nav = useNavigate();

  return (
    <div style={{
      height:"100vh",
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
      gap:"20px"
    }}>
      <h1>Welcome to Finance Tracker</h1>
      <p>Manage your money. Track your life.</p>

      <div style={{ display:"flex", gap:"15px" }}>
        <button onClick={()=>nav("/login")}>Login</button>
        <button onClick={()=>nav("/signup")}>Sign Up</button>
      </div>
    </div>
  );
}
